import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { map } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class NoticiaProvider {
  baseUrl = environment.API_URL;
  total: any = 0;
  constructor(public http: HttpClient) {}

  getTotalNaoLidas() {
    return this.total;
  }

  getInicioNoticias() {
    return this.http.get<any>(this.baseUrl + "/noticia/get-nao-lidas", {}).pipe(
      map((data) => {
        if (!data.error) {
          this.total = data;
          return data;
        } else {
          return false;
        }
      })
    );
  }

  getNoticias(categoria: any, pesquisa: any) {
    return this.http
      .post<any>(this.baseUrl + "/noticia/get-noticias-v2", {
        categoria: categoria,
        pesquisa: pesquisa,
      })
      .pipe(
        map((data) => {
          if (!data.error) {
            return data;
          } else {
            return false;
          }
        })
      );
  }

  getNoticiaById(id: any) {
    return this.http
      .post<any>(this.baseUrl + "/noticia/get-noticia", { id: id })
      .pipe(
        map((data) => {
          if (!data.error) {
            return data;
          } else {
            return false;
          }
        })
      );
  }

  getNoticiaByIdExterno(id: any) {
    return this.http
      .get<any>(this.baseUrl + "/noticia-externo/get-noticia", {
        params: { id: id },
      })
      .pipe(
        map((data) => {
          if (!data.error) {
            return data;
          } else {
            return false;
          }
        })
      );
  }

  getNoticiasFavoritas() {
    return this.http
      .post<any>(this.baseUrl + "/noticia/get-noticias-favoritas", {})
      .pipe(
        map((data) => {
          if (!data.error) {
            return data;
          } else {
            return false;
          }
        })
      );
  }

  getNoticiasDetaques() {
    let filtro: any = {};
    filtro.destaque = "1";
    return this.http
      .post<any>(this.baseUrl + "/noticia/get-noticias", { filtro: filtro })
      .pipe(
        map((data) => {
          if (!data.error) {
            return data;
          } else {
            return false;
          }
        })
      );
  }

  getCategorias(categorias: any) {
    return this.http
      .post<any>(this.baseUrl + "/noticia/get-categorias-v2", {
        filtro: categorias,
      })
      .pipe(
        map((data) => {
          if (!data.error) {
            return data;
          } else {
            return false;
          }
        })
      );
  }

  getCategoria(idCategoria: any) {
    return this.http
      .post<any>(this.baseUrl + "/noticia/get-categoria", {
        idCategoria: idCategoria,
      })
      .pipe(
        map((data) => {
          if (!data.error) {
            return data;
          } else {
            return false;
          }
        })
      );
  }

  setFavoritos(idNoticia: any) {
    return this.http
      .post<any>(this.baseUrl + "/noticia/set-favorito", {
        idNoticia: idNoticia,
      })
      .pipe(
        map((data) => {
          if (!data.error) {
            return data;
          } else {
            return false;
          }
        })
      );
  }

  postNoticiaListAno(filtro: any, idCategoria: any) {
    return this.http
      .post<any>(this.baseUrl + "/noticia/post-noticia-list-ano", {
        filtro,
        idCategoria: idCategoria.join(","),
      })
      .pipe(map((data) => (!data.error ? data : false)));
  }
}
